import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext({});
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [allowedModules, setAllowedModules] = useState(null); // null = todos (admin)

  const loadPermissions = async (profile) => {
    if (!profile) return;
    if ((profile.rol || "").toLowerCase() === "admin") {
      setAllowedModules(null);
      return;
    }
    try {
      const [{ data: modulos }, { data: ups }] = await Promise.all([
        api.get("/modulos"),
        api.get("/usuario-permisos"),
      ]);
      const modById = {};
      modulos.forEach((m) => (modById[m.id] = m.nombre));
      const names = new Set();
      ups
        .filter((up) => up.profile_id === profile.id)
        .forEach((up) => modById[up.modulo_id] && names.add(modById[up.modulo_id]));
      setAllowedModules(names);
    } catch {
      setAllowedModules(new Set());
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("cs_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(async ({ data }) => {
        setUser(data);
        await loadPermissions(data);
      })
      .catch(() => localStorage.removeItem("cs_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("cs_token", data.token);
    setUser(data.user);
    await loadPermissions(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("cs_token");
    setUser(null);
    setAllowedModules(null);
  };

  const isAdmin = (user?.rol || "").toLowerCase() === "admin";
  const canSeeModule = (name) => isAdmin || (allowedModules && allowedModules.has(name));

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, canSeeModule }}>
      {children}
    </AuthContext.Provider>
  );
};
